module.exports = __webpack_public_path__ + "static/media/4.2ac31509.jpg";